import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ActivatedRoute } from '@angular/router';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';

@Component({
  selector: 'row-container',
  templateUrl: './row-container.template.html',
  styleUrls: ['./row-container.styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RowContainer {
  @Input() row$: any;
  @Input() content$: Observable<any>;
  private eventHook: Subscription;
  private dataService: BehaviorSubject<Object>;

  constructor(
    private coreEffects: CoreEffects,
    private eventInteraction: EventInteraction,
    private route: ActivatedRoute,
    private cd : ChangeDetectorRef
  ) {
      this.dataService = new BehaviorSubject(null);
   }
   
  ngOnInit() {
    //this.content$ = this.coreEffects.getAsyncChildDataAsObservable();//(this.row$, this.route.snapshot.params, true);
    this.content$ = this.dataService.asObservable();
    this.coreEffects.getAsyncChildDataAsObservable(this.dataService, this.row$, this.route.snapshot.params, true);
  }

  ngOnDestroy(){
    if (this.dataService){
      this.dataService.complete();
      this.dataService = null;
    }
  }


} 



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/row-container/row-container.component.ts